import type { IAnyAction } from '../helpers';
import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const EXPORT_RESULT = 'DEPLOYMENT/EXPORT_RESULT' as const;

export interface IExportResultAction {
  type: typeof EXPORT_RESULT;
  payload: IAnyAction[];
}

export const exportResultPayloadSchema = Joi.array().items(
  Joi.object({
    type: Joi.string().required(),
    payload: Joi.object().optional(),
  })
);

export const exportResultActionSchema = objectSchemaOf<IExportResultAction>({
  type: Joi.string().valid(EXPORT_RESULT).required(),
  payload: exportResultPayloadSchema.required(),
});

export const exportResult = actionCreator({
  type: EXPORT_RESULT,
  schema: exportResultActionSchema,
  // NOTE: This action can be sent to any feature/topic
});
